<template>
  <PrimeDrawer
    v-model:visible="isVisible"
    position="right"
    :modal="false"
    :dismissable="false"
    :show-close-icon="false"
    class="tw-mt-32 tw-w-full tw-flex-1 tw-rounded-2xl tw-drop-shadow-2xl sm:tw-mt-0 sm:!tw-max-w-[400px] sm:tw-rounded-none"
    :pt="{
      content: {
        class: 'tw-p-6',
      },
      header: {
        class: 'tw-px-6 tw-py-4 tw-border-b tw-border-gray-200',
      },
      mask: {
        class: 'tw-bg-black/50',
      },
    }"
  >
    <template #header>
      <div class="tw-flex tw-w-full tw-items-center tw-justify-between">
        <h2 class="tw-font-outfit tw-text-2xl tw-font-medium tw-text-gray-900">
          Why do we need this?
        </h2>
        <button
          class="tw-rounded-full tw-p-2 tw-text-gray-600 hover:tw-bg-gray-100 hover:tw-text-gray-900"
          @click="close"
        >
          <DismissIconLarge class="tw-h-6 tw-w-6" />
        </button>
      </div>
    </template>

    <div class="tw-flex tw-h-full tw-flex-col tw-text-gray-700">
      <p class="tw-mb-8">
        Your security is our top priority. We strictly adhere to HIPAA guidelines to protect your
        sensitive personal health information.
      </p>
      <p class="tw-mb-8">
        We authenticate using the personally identifiable information provided. If you are legally
        representing an injured or deceased party, please provide their personal details to
        authenticate the account. If phone number is needed, enter your personal phone number.
      </p>
      <p class="tw-mb-8">For assistance, please contact us using one of the options below:</p>
      <div>
        <ContactInformation email-label="Email" phone-label="Call/text" text-size="tw-text-base" />
      </div>
    </div>
  </PrimeDrawer>
</template>

<script setup lang="ts">
import { useVModel } from '@vueuse/core'

import DismissIconLarge from '~icons/fluent/dismiss-24-regular'

const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
})

const isVisible = useVModel(props, 'visible')

const { close } = useHelpDrawer()
</script>
